var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Layout,[_c('BaseHero',{attrs:{"resource":_setup.resource,"keep-alive":""}}),_c('BaseTabPanel',{attrs:{"tabs":_setup.tabs,"address-navigation":""}}),_c(_setup.mainView,{tag:"component",attrs:{"channel":_setup.resource,"now-playing":_setup.nowPlaying}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }